export type DebugCommand = {
  id: string;
  /** Static label, or a function re-evaluated when the palette opens / filters. */
  label: string | (() => string);
  /** Extra terms for filtering (not shown). */
  keywords?: string[];
  /** When false, the command is omitted from the palette. */
  isAvailable?: () => boolean;
  perform: () => void | Promise<void>;
};

const commands = new Map<string, DebugCommand>();

/** Register a Command-K action. Returns an unregister function. */
export function registerDebugCommand(command: DebugCommand): () => void {
  commands.set(command.id, command);
  return () => {
    commands.delete(command.id);
  };
}

export function resolveCommandLabel(command: DebugCommand): string {
  return typeof command.label === 'function' ? command.label() : command.label;
}

export function getDebugCommands(): DebugCommand[] {
  return Array.from(commands.values()).filter(
    command => command.isAvailable?.() !== false
  );
}

export function filterDebugCommands(query: string): DebugCommand[] {
  const q = query.trim().toLowerCase();
  const all = getDebugCommands();
  if (!q) {
    return all;
  }
  return all.filter(command => {
    if (resolveCommandLabel(command).toLowerCase().includes(q)) {
      return true;
    }
    return (command.keywords ?? []).some(k => k.toLowerCase().includes(q));
  });
}
